import roomAPIService from "../../../roomAPIService";

export async function handleReconnections(room) {
  room.on("reconnecting", async (error) => {
    if (room.state !== "reconnecting") return;
    if (error && error.code) {
      await roomAPIService.logSessionError(error);
    }
  });
  room.on("reconnected", () => {
    if (room.state !== "connected") return;
    console.log("You reconnected to the Room!");
  });
}

export async function handleDisconnections(room) {
  /**
   * Handle when room is set to 'completed' status through
   * REST API. Just kick everyone out to Room completed page.
   * https://github.com/twilio/twilio-video.js/pull/380/files
   */
  room.on("disconnected", async (room, error) => {
    if (room.state !== "disconnected") return;
    /** User disconnected from the Room by calling 'disconnect' */
    if (!error) return;

    if (error && error.code) {
      await roomAPIService.logSessionError(error);
    }
  });
}

export default {
  handleReconnections,
  handleDisconnections,
};
